import React, { createContext } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getDeviceListApi,
  visitorMagneticCardApi,
  visitorCardExcel,
  addExtentedStay,
  getextentedValue
} from "../../api/Api";
import RouteContants from "../../constants/routesContent.json";
import { useEffect } from "react";

export const SettingsContext = createContext({});

export const SettingsContextProvider = ({ children }) => {
  const [deviceList, setDeviceList] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [statusCode, setStatusCode] = useState(0);
  const [cardExcel, setCardExcel] = useState(null);
  const [visitorsData, setVisitorsData] = useState([]);
  const [fileErrorMessage, setFileErrorMessage] = useState("");
  const [cardFile, setCardFile] = useState(null);
  const [cardFileDownload, setCardFileDownload] = useState();
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [extentendStayValue, setExtentendStayValue] = useState("Select");
  const [extentedStayRequired, setExtentedStayRequired] = useState(false);
  const [extentedSpinnerStatus, setExtentedSpinnerStatus] = useState(false);
  const navigate = useNavigate();
  const navigateToPermissions = () => {
    navigate(RouteContants.SETTINGS_PERMISSION);
  };
  const goBack = () => {
    navigate(-1);
  };

  const navigateToAddDevice = () => {
    navigate(RouteContants.ADD_DEVICE);
  };
  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteContants.LOGIN);
  };
  const navigateToEditDevice = (deviceData) => {
    navigate(RouteContants.ADD_DEVICE, {
      state: {
        isEdit: true,
        deviceData,
      },
    });
  };

  const getDeviceData = async () => {
    try {
      const response = await getDeviceListApi();
      if (response.data.status === 200) {
        setDeviceList(response?.data?.data);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  // file upload validation
  const handleCardValidation = (value) => {
    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    if (!value) {
      setFileErrorMessage("Upload .xlsx file");
      return false;
    } else if (!allowedTypes.includes(value.type)) {
      setFileErrorMessage("Please upload .xlsx file");
      return false;
    }
    // else if (value.size > maxSizeInBytes) {
    //   setImageErrorMessage(pageContent.imageSizeValidationMessage);
    //   return false;
    // }
    else {
      setFileErrorMessage("");
      return true;
    }
  };

  const handleAlertSubmit = () => {
    setShowAlert(false);
    //setCardExcel(null);
  };

  const handleMagneticUpload = (event) => {
    // handleCardValidation(event?.target?.files[0]);
    setCardFile(event?.target?.files[0]);
    setCardExcel(event?.target?.files[0]?.name);
  };

  const editvistorData = () => {
    let formData = new FormData();
    formData.append("visitorCard", cardFile);

    return formData;
  };

  const callGetVisitorCardExcel = async () => {
    try {
      const getExcel = await visitorCardExcel();
      if (getExcel.status === 200) {
        setSpinnerStatus(false);
        setCardFileDownload(getExcel.data.data.filename);
      }
    } catch (error) {
      setSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (
        error?.response?.data?.status === 401 ||
        error?.response?.data?.status === 400 ||
        error?.response?.data?.status === 403
      ) {
        const errorMessage = error?.response?.data?.message;
        setShowAlert(true);
        setAlertMessage(errorMessage);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };

  const visitorCardSubmit = async (e) => {
    e.preventDefault();
    const cardData = {
      visitorCard: cardFile,
    };
    const fileData = handleCardValidation(cardFile);
    if (fileData) {
      setSpinnerStatus(true);
      try {
        const file = await visitorMagneticCardApi(editvistorData(), cardData);
        if (file?.data?.status === 200) {
          setSpinnerStatus(false);
          setShowAlert(true);
          setAlertMessage(file?.data?.message);
          setCardExcel(null);
          setCardFile(null);
        }
      } catch (error) {
        setSpinnerStatus(false);
        setStatusCode(error?.response?.data?.status);
        if (
          error?.response?.data?.status === 401 ||
          error?.response?.data?.status === 400 ||
          error?.response?.data?.status === 403
        ) {
          const errorMessage = error?.response?.data?.message;
          setShowAlert(true);
          setAlertMessage(errorMessage);
        } else {
          setShowAlert(true);
          setAlertMessage("Something went wrong");
        }
      }
    }
  };

  useEffect(() => {
    callGetVisitorCardExcel();
    getExtentedStayValue()
  }, []);

  const submitExtentedStayData = async (e) => {
    e.preventDefault();
    setExtentedSpinnerStatus(true);
    if (extentendStayValue === 'Select'){
      setExtentedStayRequired(true);
      setExtentedSpinnerStatus(false);
      setShowAlert(true);
      setAlertMessage("Please select an extended stay");
       
     }else{
      setExtentedStayRequired(false);
      setExtentedSpinnerStatus(true);
      setShowAlert(false);
     
     
    const extentedData = {
      extendedStay: extentendStayValue.name ? extentendStayValue.name :extentendStayValue,
    };
    try {
      const extentedResponse = await addExtentedStay(extentedData);
      if (extentedResponse.status === 200) {
     
        setAlertMessage("Extented stay configuration time updated successfully");
      
        setShowAlert(true);

      }
    } catch (error) {
      setExtentedSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (
        error?.response?.data?.status === 401 ||
        error?.response?.data?.status === 400 ||
        error?.response?.data?.status === 403
      ) {
        const errorMessage = error?.response?.data?.message;
        setShowAlert(true);
        setAlertMessage(errorMessage);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  }
  };
  const getExtentedStayValue = async () =>{
    setExtentedSpinnerStatus(true);
    try {
      const extentedResponse = await getextentedValue();
      
      if (extentedResponse.status === 200) {
        setExtentedSpinnerStatus(false);
       setExtentendStayValue(extentedResponse.data.data.stayHour)
      }
    } catch (error) {
      setExtentedSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (
        error?.response?.data?.status === 401 ||
        error?.response?.data?.status === 400 ||
        error?.response?.data?.status === 403
      ) {
        const errorMessage = error?.response?.data?.message;
        setShowAlert(true);
        setAlertMessage(errorMessage);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  }

  const providerValue = {
    navigateToPermissions,
    navigateToAddDevice,
    navigateToEditDevice,
    goBack,
    getDeviceData,
    deviceList,
    alertMessage,
    setAlertMessage,
    showAlert,
    handleAlertSubmit,
    setShowAlert,
    logout,
    statusCode,
    handleMagneticUpload,
    spinnerStatus,
    setFileErrorMessage,
    fileErrorMessage,
    visitorCardSubmit,
    cardExcel,
    cardFileDownload,
    
    
    // new changes
    extentendStayValue, setExtentendStayValue,
    submitExtentedStayData,
    setExtentedStayRequired,
    setSpinnerStatus,
    getExtentedStayValue,
    setExtentedSpinnerStatus,extentedSpinnerStatus
    
  };
  return (
    <SettingsContext.Provider value={providerValue}>
      {children}
    </SettingsContext.Provider>
  );
};
